import React from 'react'
import Lottie from 'lottie-react'
import loadAnimation from './load-animation.json'

interface LoadingAnimationProps {
  size?: number
  className?: string
}

export function LoadingAnimation({ size = 48, className = '' }: LoadingAnimationProps) {
  return (
    <Lottie 
      animationData={loadAnimation}
      loop={true}
      autoplay={true}
      style={{ width: size, height: size }}
      className={className}
    />
  )
}

// Fallback to CSS spinner if Lottie fails
export function LoadingSpinner({ size = 48, className = '' }: LoadingAnimationProps) {
  const sizeClasses = {
    24: 'w-6 h-6',
    32: 'w-8 h-8',
    48: 'w-12 h-12',
    64: 'w-16 h-16'
  }
  
  const sizeClass = sizeClasses[size as keyof typeof sizeClasses] || 'w-12 h-12'
  
  return (
    <div className={`${sizeClass} mx-auto border-2 border-gray-300 border-t-black dark:border-gray-600 dark:border-t-white rounded-full animate-spin ${className}`} />
  )
}